import { Autosuggest, AutosuggestProps } from '@amzn/awsui-components-console';
import { useEffect, useState, RefObject } from 'react';

type Props = AutosuggestProps & {
  regex?: RegExp | false;
  ariaRequired?: boolean;
};

export const Autobot = ({
  value,
  regex,
  ariaRequired = false,
  onChange,
  ...etc
}: Props) => {
  // Current value
  const [val, setVal] = useState(value);

  // Is a regex specified but the input doesn't match?
  // Is the input empty (only if ariaRequired is true)?
  const [wrong, setWrong] = useState(false);

  // Update the input's content if a new value is passed via props
  useEffect(() => {
    setVal(value);
  }, [value]);

  useEffect(() => {
    // Validate if regex is set
    setWrong(
      !etc.disabled &&
        Boolean(
          (regex && !regex.test(val)) || (ariaRequired && val?.trim() === '')
        )
    );
  }, [val]);

  return (
    <Autosuggest
      value={val}
      onChange={(d) => {
        // Update current value
        setVal(d.detail.value);
        onChange?.(d);
      }}
      invalid={wrong}
      {...etc}
    />
  );
};
